import { useEffect, useState } from "react";
import { DeleteUserModal, Header } from "../components";
import { useMemo } from "react";
import Table from "../components/Table";
import { useStateContext } from "../contexts/ContextProvider";
import { useModal } from "../contexts/ModalContext";
import { Box, Tooltip, IconButton } from "@mui/material";
import { Send, DeleteForever } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import { useFetchContext } from "../contexts/FetchContext";
import CustomModal from "../components/CustomModal";
const Users = () => {
  const navigate = useNavigate();
  const { fetchAllUsers } = useFetchContext();
  const { currentMode } = useStateContext();
  const { modal, openModal, closeModal } = useModal();
  const [pagination, setPagination] = useState({
    pageIndex: 1, // zero-based page index
    pageSize: 10,
  });
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (pagination) {
      (async () => {
        const { data, totalCount } = await fetchAllUsers(
          pagination.pageIndex,
          pagination.pageSize,
        );
        setUsers(data);
        setTotalCount(totalCount);
      })();
    }
  }, [pagination]);

  const columns = useMemo(() => [
    {
      accessorFn: (row) => `${row.firstName} ${row.lastName}`, // Combine first and last name
      header: "Name",
      size: 80,
    },
    {
      accessorFn: (row) => row.email, // Directly map the email
      header: "Email",
      size: 80,
    },
    {
      accessorFn: (row) =>
        row.status === "verified" ? (
          <span className="bg-green-100 text-green-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-xl dark:bg-green-900 dark:text-green-300">
            Verified
          </span>
        ) : row.status === "reviewing" ? (
          <span className="bg-orange-100 text-yellow-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-xl dark:bg-yellow-900 dark:text-yellow-300">
            Reviewing
          </span>
        ) : (
          <span className="bg-red-100 text-orange-800 text-sm font-medium me-2 px-2.5 py-0.5 rounded-xl dark:bg-orange-900 dark:text-orange-300">
            Suspended
          </span>
        ),
      header: "Status",
      size: 80,
    },
  ]);

  return (
    <div className="m-2 md:m-10 p2 md:p-10 dark:bg-secondary-dark-bg bg-white rounded-3xl">
      <div className="flex w-full justify-between items-center">
        <Header title="Users" />
      </div>
      {users?.length < 0 ? (
        <div className="min-h-[20rem] w-full items-center justify-center flex">
          <Loading
            color={currentMode === "Dark" ? "#20232A" : "#fafafa"}
            bgColor={currentMode === "Dark" ? "#fafafa" : "#20232A"}
          />
        </div>
      ) : (
        <div className="w-full grid">
          <Table
            data={users}
            pagination={pagination}
            onPaginationChange={(newPagination) => {
              console.log("Pagination updated", newPagination);
              setPagination(newPagination);
            }}
            totalCount={totalCount}
            renderRowActions={({ row, table }) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Tooltip arrow placement="left" title="Delete User">
                  <IconButton
                    onClick={() => openModal("deleteUser", row.original)}
                  >
                    <DeleteForever className="dark:text-white-shade text-black-shade" />
                  </IconButton>
                </Tooltip>

                <Tooltip arrow placement="right" title="View Details">
                  <IconButton
                    onClick={() => {
                      navigate(`/user/${row.original._id}`);
                    }}
                  >
                    <Send className="dark:text-white-shade text-black-shade" />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            columns={columns}
          />
        </div>
      )}

      <CustomModal open={modal?.type === "deleteUser"} onClose={closeModal}>
        <DeleteUserModal onClose={closeModal} data={modal?.data} />
      </CustomModal>
    </div>
  );
};

export default Users;
